<template>
  <div class="content">
    <template v-if="show_loading_message">
      <h6 class="text-center"><strong>Fetching Rate Cards...</strong></h6>
    </template>
    <template v-if="rateCards.length">
      <div class="d-flex justify-content-end mb-4 gap-1">
        <div>
          <select class="custom-select" v-model="filtered_lawfirm">
            <option value="">All Lawfirms</option>
            <option :value="l.name" v-for="l in lawfirms" :key="l.name">
              {{ l.name }}
            </option>
          </select>
        </div>
        <div>
          <select class="custom-select" v-model="filtered_carrier">
            <option value="">All Carriers</option>
            <option :value="l.label" v-for="l in carriers" :key="l.label">
              {{ l.label }}
            </option>
          </select>
        </div>
        <button class="btn btn-sync" @click="syncRateCards">
          <font-awesome-icon
            class="text-white mr-2"
            :icon="['fas', 'sync-alt']"
          />
          Sync Rate Cards
        </button>
      </div>
      <div class="mb-4">
        <input
          type="search"
          name="ratecardname"
          class="searchbar"
          id="ratecardname"
          v-model.trim="rate_card_name"
          placeholder="Search by Rate Card Name"
        />
      </div>
      <div
        v-for="ratecard in filteredRateCards"
        :key="ratecard.rateCardId"
        :id="ratecard.rateCardId"
      >
        <RateCard :rate-card-id="ratecard.id" :key="ratecard.rateCardId" />
      </div>
    </template>
  </div>
</template>

<script>
import rateCardService from "@/services/rateCardService";
import RateCard from "@/components/RateCard";
import fieldsService from "@/services/fieldsService";
import lawfirmsService from "@/services/lawfirmsService";
import tasksService from "@/services/tasksService";
import masterService from "@/services/masterrecordService";
import { mapState } from "vuex";
import { EventBus } from "@/EventBus";
export default {
  props: ["showForm"],
  name: "Home",
  components: { RateCard },
  created() {
    this.show_loading_message = true;
    EventBus.$emit("toast", {
      title: "",
      message: "Fetching Rate Cards & Master Data",
      variant: "success",
    });
    Promise.all([
      rateCardService.getRateCards(),
      fieldsService.getCustomFields(),
      lawfirmsService.getLawfirms(),
      masterService.getRoleTasksMasterMappings(),
    ]).then((response) => {
      this.show_loading_message = false;
      this.$store.commit("rateCards", response[0].data.data);
      this.$store.commit("customFields", response[1].data.data);
      this.$store.commit("lawfirms", response[2].data.data);
      this.$store.commit(
        "updateRoleTasksMasterMappings",
        response[3].data.data
      );
    });

    tasksService.getTasks().then((response) => {
      this.$store.commit("tasks", response.data.data);
    });
  },
  computed: {
    filteredRateCards() {
      return this.rateCards.filter((r) => {
        return (
          (this.rate_card_name === "" ||
            r.title
              .toLowerCase()
              .includes(this.rate_card_name.toLowerCase())) &&
          ((this.filtered_lawfirm === "" && this.filtered_carrier === "") ||
            (r.mappings &&
              r.mappings.some(
                (m) =>
                  m.lawfirm.name ===
                    (this.filtered_lawfirm || m.lawfirm.name) &&
                  m.carrier.name === (this.filtered_carrier || m.carrier.name)
              )))
        );
      });
    },
    carriers() {
      return this.$store.getters.customFieldById(598475).choices;
    },
    ...mapState({
      lawfirms: (state) => state.lawfirms,
      rateCards: (state) => state.rateCards,
    }),
  },
  methods: {
    syncRateCards() {
      EventBus.$emit("toast", {
        title: "",
        message: "Initiated Rate Cards Sync from Mavenlink",
        variant: "success",
      });
      rateCardService.syncRateCards().then((response) => {
        this.$store.commit("rateCards", response.data.data);
        EventBus.$emit("toast", {
          title: "",
          message: "Sync Successfull",
          variant: "success",
        });
      });
    },
  },
  data() {
    return {
      rate_card_name: "",
      filtered_lawfirm: "",
      filtered_carrier: "",
      show_loading_message: true,
    };
  },
};
</script>
<style  lang="scss" scoped>
.searchbar {
  width: 100%;
  outline: none;
  border-radius: 10px;
  border: 1px solid #2b2d4250;
  padding: 10px 10px 10px 20px;
  //box-shadow: inset 3px 3px 5px rgba(0, 0, 0, 0.1), inset -3px -3px 5px #fff;
  color: $primary-color;
  font-weight: bold;
  &::placeholder {
    color: $secondary-color;
    opacity: 0.6;
    font-weight: normal;
  }
}
.btn-sync {
  border-radius: 20px;
  outline: none;
  border: 1px solid #2b2d4250;
  //box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1), -3px -3px 5px #fff;
  background-color: $primary-color;
  color: $background-color;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  &:active {
    transform: scale(0.95);
  }
}
</style>